export default "__VITE_ASSET__CdGiKerN__"